import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";
import useI18n from "../../i18n/useI18n";

const ToolSeoCTA = ({
  badge,
  title,
  description,
  primaryLabel,
  primaryTo = "/register",
  secondaryLabel,
  secondaryTo = "/features",
}) => {
  const { isDark } = useThemeMode();
  const { t } = useI18n();
  const colors = useMemo(() => getMarketingTheme(isDark), [isDark]);

  const tt = (key, fallback) => {
    const value = t(key);
    return value === key ? fallback : value;
  };

  const resolvedBadge = badge ?? tt("common.startFree", "Start free");
  const resolvedTitle =
    title ?? tt("toolsSeoCta.title", "Build your content workflow with more clarity");
  const resolvedDescription =
    description ??
    tt(
      "toolsSeoCta.description",
      "Start free and use Hookora to create content with more speed, structure, and consistency."
    );
  const resolvedPrimaryLabel =
    primaryLabel ?? tt("common.createFreeAccount", "Create Free Account");
  const resolvedSecondaryLabel =
    secondaryLabel ?? tt("common.exploreFeatures", "Explore Features");

  return (
    <section style={{ padding: "0 20px 84px", background: colors.sectionBg }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div
          style={{
            background: colors.darkCtaBg,
            color: colors.darkCtaText,
            borderRadius: "30px",
            padding: "36px 28px",
            boxShadow: colors.shadow,
          }}
        >
          <div style={{ maxWidth: "760px" }}>
            <div
              style={{
                display: "inline-flex",
                padding: "7px 12px",
                borderRadius: "999px",
                background: "rgba(255,255,255,0.12)",
                color: "#e0e7ff",
                fontWeight: "700",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              {resolvedBadge}
            </div>

            <h2
              style={{
                margin: "0 0 12px",
                fontSize: "clamp(2rem, 4vw, 3rem)",
                lineHeight: "1.08",
              }}
            >
              {resolvedTitle}
            </h2>

            <p
              style={{
                margin: "0 0 22px",
                color: colors.darkCtaMuted,
                lineHeight: "1.75",
                fontSize: "16px",
                maxWidth: "680px",
              }}
            >
              {resolvedDescription}
            </p>

            <div
              style={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <Link
                to={primaryTo}
                style={{
                  textDecoration: "none",
                  background: "#ffffff",
                  color: "#111827",
                  padding: "14px 18px",
                  borderRadius: "12px",
                  fontWeight: "800",
                }}
              >
                {resolvedPrimaryLabel}
              </Link>

              <Link
                to={secondaryTo}
                style={{
                  textDecoration: "none",
                  background: "transparent",
                  color: "#ffffff",
                  padding: "14px 18px",
                  borderRadius: "12px",
                  fontWeight: "800",
                  border: "1px solid rgba(255,255,255,0.24)",
                }}
              >
                {resolvedSecondaryLabel}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ToolSeoCTA;